import { render, staticRenderFns } from "./FormSegmentedControl.vue?vue&type=template&id=31ff161f"
import script from "./FormSegmentedControl.vue?vue&type=script&lang=js"
export * from "./FormSegmentedControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports